import {computed, Ref} from 'vue'

import {CrudObject, Graphql, CrudCollection} from "@hc/graphql"

export type CrudBreadcrumpRoute = {
  name: string
  params?: Record<string, any>
}

export type CrudBreadcrumpItem = {
  text: string
  to?: string | CrudBreadcrumpRoute
}

type CrudCollectionBreadcrumpParams = {
  collection: string,
  title?: string,
  recursive?: boolean,
  additional?: CrudBreadcrumpItem[]
}

type CrudObjectBreadcrumpParams = {
  target: Ref<CrudObject>,
  title?: string,
  additional?: CrudBreadcrumpItem[]
}


const objectPath = (target: CrudObject): CrudBreadcrumpItem[] => {
  const collection = Graphql.collection(target.__typename)
  const items = []
  if(collection.parent){
    const parent = target[collection.parent]
    if(parent){
      items.push(...objectPath(parent))
    }
  }
  items.push({
    text: collection.objectTitle(target),
    to: target.id ? {name: 'crud.object', params: {collection: collection.name, id: target.id} } : null,
  })
  return items
}

const collectionPath = (collection: CrudCollection, recursive: boolean): CrudBreadcrumpItem[] => {
  const items = []
  if(recursive && collection.parentCollection){
    items.push(...collectionPath(collection.parentCollection, recursive))
  }
  items.push({
    text: collection.title,
    to: {name: 'crud.list', params: {collection: collection.name} },
  })
  return items
}


export function useCrudBreadcrump(){
  const forObject = (target: CrudObject, pageTitle: string = null, ...additional: CrudBreadcrumpItem[]): CrudBreadcrumpItem[] => {
    if(!target) return []
    if(!target.__typename) return
    const items = []
    items.push({text: 'Home', to: { name: 'home' }})
    items.push(...objectPath(target))
    if(additional.length > 0) items.push(...additional)
    if(pageTitle){
      items.push({
        text: pageTitle,
      })
    }
    return items
  }

  const forCollection = (collectionName: string, pageTitle: string = null,recursive: boolean = false, ...additional: CrudBreadcrumpItem[]): CrudBreadcrumpItem[] => {
    const collection = Graphql.collection(collectionName)
    const items = []
    items.push({text: 'Home', to: { name: 'home' }})
    items.push(...collectionPath(collection, recursive))
    if(pageTitle){
      items.push({text: pageTitle })
    }
    return items
  }

  return {
    forObject,
    forCollection
  }
}

export function useCrudCollectionBreadcrumb(params: CrudCollectionBreadcrumpParams){
  return computed(()=>{
    const collection = Graphql.collection(params.collection)
    const items = []
    items.push({text: 'Home', to: { name: 'home' }})
    items.push(...collectionPath(collection, params.recursive))
    if(params.additional) items.push(...params.additional)
    if(params.title) items.push({text: params.title })
    return items
  })
}

export function useCrudObjectBreadcrumb(params: CrudObjectBreadcrumpParams){
  return computed(()=>{
    const target = params.target.value
    if(!target) return []
    if(!target.__typename) return
    const items = []
    items.push({text: 'Home', to: { name: 'home' }})
    items.push(...objectPath(target))
    if(params.additional) items.push(...params.additional)
    if(params.title) items.push({text: params.title})
    return items
  })
}